import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ConfigurationService } from '../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class LandandbuildingsService {

  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }
  apiUrl = this.ConfigService.getAPIBaseUrl() + 'api/LandAndBuildings/';

  insertlandbuilding(data: any) {
    debugger
    const httpOptions = { headers: new HttpHeaders({ 'content-type': 'application/json' }) }
    return this.http.post(this.apiUrl + 'Add', data)
  }

  getbuilding(id) {
    debugger
    return this.http.get(this.apiUrl + 'GetOne?id='+id)
  }

  getbuildingly(id) {
    debugger
    return this.http.get(this.apiUrl + 'GetOneLY?id=' + id)
  }
}
